import {
  makeDonation, getPaymentIntentBare, cancelPaymentIntent,
  getSponsorships, calculatedTotalDonationAmount, getTotalAmountWithFrequency
} from './DonationNoLoginService'
import { evenRound } from '../../util/NumberUtils';
import { extractError } from '../../api/ErrorUtil';
import _ from "lodash";
import { formatDateToYYYYMMDD } from 'util/Date';


export const donationNoLoginFormDataInitialState = {
  readOnly: false,
  status: "",
  errors: {},
  donorEmailAddress: "",
  firstName: "",
  lastName: "",
  address: "",
  city: "",
  state: "ON",
  country: "CA",
  zip: "",
  mobilePhoneNumber: "",
  donationLineItems: [],
  totalDonationAmount: null,
  paymentIntent: {},
  currentDonationCause: "",
  currentDonationCauseValue: "0.00",
  currentPage: 0,
  titleFilter: "",
  sponsorships: [],
  selectedSponsorships: [],
  selectedCauseAttributes: [],
  sponsorshipCause: false,
  causeAttrDescription: ""
}

export const AsyncDonationNoLoginFormHandlers = {
  FORM_SUBMIT: ({ dispatch, getState, signal }) => async (action) => {
    let { stripe, formData } = action.payload;

    dispatch({ type: 'FORM_SUBMITTING', payload: { paymentElement: formData.paymentElement } });

    if (!formData.paymentElementComplete) {
      dispatch({ type: 'FORM_SUBMIT_FAIL', payload: { error: { message: 'Payment information is invalid', errors: {} }, paymentElement: formData.paymentElement } });
      return;
    }

    try {
      let { transactionNumber, receiptNumber, paymentAmount } = await makeDonation(stripe, formData);
      dispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: { transactionNumber, receiptNumber, paymentAmount, paymentElement: formData.paymentElement } });
    } catch (error) {
      let errorMsg = extractError(error);
      dispatch({ type: 'FORM_SUBMIT_FAIL', payload: { error: errorMsg, paymentElement: formData.paymentElement } });
    }

  },

  GET_PAYMENT_INTENT: ({ dispatch, getState, signal }) => async (action) => {
    let paymentIntent = undefined;
    try {
      dispatch({ type: 'GETTING_PAYMENT_INTENT' });
      paymentIntent = await getPaymentIntentBare(getState());
      dispatch({ type: 'GET_PAYMENT_INTENT_SUCCESS', payload: { paymentIntent: paymentIntent } });
    } catch (error) {
      let errorMsg = extractError(error);
      dispatch({ type: 'GET_PAYMENT_INTENT_FAIL', payload: { error: errorMsg } });
    }
  },
  FORM_CANCEL: ({ dispatch, getState, signal }) => async (action) => {
    let errorMsg = null;
    let cancelResp = null;
    try {
      cancelResp = await cancelPaymentIntent(getState().paymentIntent.id)
    } catch (error) {
      errorMsg = extractError(error);
    }
    dispatch({ type: 'FORM_CANCELLED', payload: { cancelResp: cancelResp, error: errorMsg } });
  },

  FETCH_SPONSORSHIPS: ({ dispatch, getState, signal }) => async (action) => {
    let { donationCauseId, titleFilter } = action.payload;

    if (!donationCauseId) {
      dispatch({ type: 'FETCH_SPONSORSHIPS_SUCCESS', payload: { sponsorships: [], totalPages: 0, titleFilter: titleFilter } });
      return;
    }
    let state = getState();
    let keywordFilter = titleFilter;
    if (!keywordFilter) {
      keywordFilter = state.titleFilter;
    }
    const currentPage = 0;
    try {

      let sponsorshipsResp = await getSponsorships(donationCauseId, currentPage, keywordFilter)

      dispatch({ type: 'FETCH_SPONSORSHIPS_SUCCESS', payload: { sponsorships: sponsorshipsResp.content, totalPages: sponsorshipsResp.totalPages, titleFilter: keywordFilter } });
    } catch (error) {
      let errorMsg = extractError(error);
      dispatch({ type: 'FETCH_SPONSORSHIPS_FAIL', payload: { errors: errorMsg, titleFilter: keywordFilter } });

    }

  },

  HANDLE_PAGING: ({ dispatch, getState, signal }) => async (action) => {
    let { currentPage } = action.payload;
    let state = getState();
    try {
      let sponsorships = await getSponsorships(state.currentDonationCause, currentPage, state.titleFilter)
      dispatch({ type: 'HANDLE_PAGING_SUCCESS', payload: { sponsorships: sponsorships.content, totalPages: sponsorships.totalPages, currentPage: currentPage } });
    } catch (error) {
      let errorMsg = extractError(error);
      dispatch({ type: 'HANDLE_PAGING_FAIL', payload: { errors: errorMsg } });
    }

  },

  DONATION_CAUSE_CHANGE: ({ dispatch, getState, signal }) => async (action) => {
    let state = getState();
    let { selectedDonationCauseId } = action.payload;
    let fetchSponsorships = false;
    for (let donationLineItem of state.donationLineItems) {
      if (donationLineItem.causeId === selectedDonationCauseId && donationLineItem.sponsorshipCause) {
        fetchSponsorships = true;
      }
    }
    dispatch({ type: 'MOD_STATE_FOR_DONCAUSE_CHANGE', payload: action.payload });
    if (fetchSponsorships){
      dispatch({ type: 'FETCH_SPONSORSHIPS', payload: { donationCauseId: selectedDonationCauseId } })
    }
  }


};

export const DonationNoLoginFormDataReducer = (state, action) => {
  if (action.type === 'ADD_TO_CART_SUCCESS') {
    return {
      ...state,
      currentDonationCause: "",
      currentDonationCauseValue: "",
      selectedCauseAttributes: [],
      selectedSponsorships: [],
      sponsorshipCause: false,
      mediaType: "",
      infoMessage: "Item added to cart successfully"
    };
  }

  if (action.type === 'RESET_MESSAGE_AND_ERRORS'){
    return {
      ...state,
      errors:{},
      infoMessage:""
    }
  }
if (action.type === 'GETTING_PAYMENT_INTENT') {
  return {
    ...state,
    readOnly: true,
    status: "Fetching Payment intent...",
    infoMessage: "",
    errors: {}
  }
}

if (action.type === 'GET_PAYMENT_INTENT_SUCCESS') {
  let { paymentIntent } = action.payload;
  return {
    ...state,
    readOnly: false,
    status: "",
    infoMessage: "",
    paymentIntent: paymentIntent
  }
}

if (action.type === 'GET_PAYMENT_INTENT_FAIL') {
  let { error } = action.payload;
  return {
    ...state,
    status: "Fetching payment intent failed",
    readOnly: false,
    infoMessage: "",
    errors: error
  };
}

if (action.type === 'FETCH_SPONSORSHIPS_SUCCESS') {
  let { sponsorships, totalPages, titleFilter } = action.payload;
  let selectedSponsorships = [];
  if (!_.isEmpty(state.selectedSponsorships)) {
    selectedSponsorships = state.selectedSponsorships;
  }
  return {
    ...state,
    selectedSponsorships: selectedSponsorships,
    sponsorships: sponsorships,
    totalPages: totalPages,
    titleFilter: titleFilter,
    currentPage: 0
  }
}

if (action.type === 'FETCH_SPONSORSHIPS_FAIL') {
  let { errors, titleFilter } = action.payload;
  return {
    ...state,
    sponsorships: [],
    status: (errors?.httpStatus !== 404) ? errors.message : "",
    errors: (errors?.httpStatus !== 404) ? errors : {},
    titleFilter: titleFilter
  }
}

if (action.type === 'HANDLE_PAGING_SUCCESS') {
  let { sponsorships, totalPages, currentPage } = action.payload;
  return {
    ...state,
    currentPage: currentPage,
    sponsorships: sponsorships,
    totalPages: totalPages
  }
}

if (action.type === 'HANDLE_PAGING_FAIL') {
  let { errors } = action.payload;
  return {
    ...state,
    sponsorships: [],
    status: (errors?.httpStatus !== 404) ? errors.message : "",
    errors: (errors?.httpStatus !== 404) ? errors : {}
  }
}


if (action.type === 'FORM_CANCELLED') {
  let { cancelResp, error } = action.payload;
  console.log("Cancel paymentintent response", cancelResp);
  return {
    ...state,
    status: "Payment Cancelled",
    readOnly: false,
    infoMessage: '',
    paymentIntent: {},
    errors: {}
  }

}

if (action.type === 'UPDATE_DONATION_ITEMS') {
  let { donationCauses, selectedCause } = action.payload;

  let lineItems = [];
  for (let i = 0; i < donationCauses.length; i++) {
    lineItems[i] = {
      causeId: donationCauses[i].id,
      causeCode: donationCauses[i].donationCauseCode,
      lineItemAmount: "0.00",
      lineItemDescription: donationCauses[i].donationCauseDescription,
      donationCauseAttributes: donationCauses[i].donationCauseAttributes,
      sponsorshipCause: donationCauses[i].sponsorshipCause,
      mediaType: donationCauses[i].mediaType
    };

  }

  let currentState = selectDonationCause(selectedCause?.id, lineItems);
  return {
    ...state,
    ...currentState,
    currentDonationCauseValue:"0.00",
    donationLineItems: lineItems,
  }
}

if (action.type === 'MOD_STATE_FOR_DONCAUSE_CHANGE') {
  let { selectedDonationCauseId } = action.payload;
  let currentState = selectDonationCause(selectedDonationCauseId, state.donationLineItems);
  return {
    ...state,
    ...currentState,
  }
}

if (action.type === 'UPDATE_DONOR_DETAILS') {
  let { profile } = action.payload;
  return {
    ...state,
    donorEmailAddress: profile.email,
    firstName: profile.firstName,
    lastName: profile.lastName,
    address: profile.address,
    city: profile.city,
    state: profile.state,
    country: profile.country,
    zip: profile.zip,
    mobilePhoneNumber: profile.mobilePhoneNumber

  }
}

if (action.type === 'FORM_SUBMITTING') {
  let { paymentElement } = action.payload;
  paymentElement.update({ readOnly: true });
  return {
    ...state,
    readOnly: true,
    status: "Submitting Form...",
    errors: {}
  }
}

if (action.type === 'FORM_SUBMIT_SUCCESS') {
  let { transactionNumber, receiptNumber, paymentAmount, paymentElement } = action.payload;
  paymentElement.clear();
  paymentElement.update({ readOnly: true });
  let dliClone = _.cloneDeep(state.donationLineItems);
  for (let donationLineItem of dliClone) {
    donationLineItem.lineItemAmount = 0.00;
  }
  let newState = {
    ...donationNoLoginFormDataInitialState,
    status: "",
    readOnly: false,
    infoMessage: `Payment Successful in the amount of $${paymentAmount}. Receipt Number: ${receiptNumber} Transaction Number: ${transactionNumber}`,
    donationLineItems: dliClone
  };
  return newState;
}

if (action.type === 'FORM_SUBMIT_FAIL') {
  let { error, paymentElement } = action.payload;
  paymentElement.update({ readOnly: false });
  let newState = {
    ...state,
    status: "",
    readOnly: false,
    errors: error
  };
  return newState;
}

if (action.type === 'FIELD_EDIT') {
  const { name, value } = action.payload;
  let newState = {
    ...state,
    [name]: value

  };
  return newState;
}

if (action.type === 'SELECT_SPONSORSHIP') {
  const { sponsorship, check } = action.payload;
  let donationAmount = 0.00

  let selectedSponsorships = _.cloneDeep(state.selectedSponsorships);
  if (check) {
    //set freqAmount and frequency
    if (!sponsorship.hasOwnProperty('frequency')) {
      sponsorship.frequency = 'MONTHLY';
    }
    sponsorship.freqAmount = getTotalAmountWithFrequency(sponsorship);
    selectedSponsorships.push(sponsorship);

    if (!state.currentDonationCauseValue) {
      donationAmount = sponsorship.freqAmount;
    } else {
      donationAmount = evenRound(sponsorship.freqAmount + parseFloat(state.currentDonationCauseValue), 2);
    }
  } else {
    let indexToRemove = null;
    for (let i = 0; i < selectedSponsorships.length; i++) {
      if (selectedSponsorships[i].id === sponsorship.id) {
        indexToRemove = i;
        break;
      }
    }

    //subtract donation cause value and then from list
    donationAmount = evenRound(parseFloat(state.currentDonationCauseValue) - sponsorship.freqAmount, 2)
    if (indexToRemove === null) {
      return;
    }
    if (indexToRemove === 0) {
      selectedSponsorships.shift();
    } else {
      selectedSponsorships.splice(indexToRemove, indexToRemove);
    }

  }
  let newState = {
    ...state,
    selectedSponsorships: selectedSponsorships,
    currentDonationCauseValue: donationAmount

  };
  return newState;
}

if (action.type === 'ARRAY_FIELD_EDIT') {
  const { idx, name, value } = action.payload;
  const donationLineItems = state[name];
  donationLineItems[idx].lineItemAmount = value;
  let newState = {
    ...state,
    donationLineItems: donationLineItems
  };
  return newState;
}


if (action.type === 'ADD_DONATION') {
  let dliClone = _.cloneDeep(state.donationLineItems);
  for (let donationLineItem of dliClone) {
    if (donationLineItem.causeId === state.currentDonationCause) {
      donationLineItem.lineItemAmount = state.currentDonationCauseValue
      donationLineItem.selectedSponsorships = state.selectedSponsorships.filter(sps => sps.donationCauseId === donationLineItem.causeId);
    }
  }
  let totalDonationAmount = calculatedTotalDonationAmount(dliClone);
  return {
    ...state,
    selectedCauseAttributes: [],
    sponsorshipCause: false,
    mediaType: "",
    currentDonationCause: "",
    currentDonationCauseValue: "",
    sponsorships: [],
    donationLineItems: dliClone,
    totalDonationAmount: totalDonationAmount
  }
}

if (action.type === 'DELETE_DONATION') {
  const { causeId } = action.payload;
  let dliClone = _.cloneDeep(state.donationLineItems);

  let selectedSponsorships = state.selectedSponsorships;

  for (let donationLineItem of dliClone) {
    if (donationLineItem.causeId === causeId) {
      donationLineItem.lineItemAmount = 0
      selectedSponsorships = state.selectedSponsorships.filter(sps =>
        !donationLineItem.selectedSponsorships.some(dliSps => dliSps.id === sps.id)
      );
      donationLineItem.selectedSponsorships = []
    }
  }
  let totalDonationAmount = calculatedTotalDonationAmount(dliClone);
  return {
    ...state,
    donationLineItems: dliClone,
    totalDonationAmount: totalDonationAmount,
    selectedSponsorships: selectedSponsorships
  }
}

if (action.type === 'ARRAY_FIELD_ROUND') {
  const { idx, name, value } = action.payload;
  const donationLineItems = state[name];
  if (evenRound(value, 2) <= 0) {
    donationLineItems[idx].lineItemAmount = "0.00";
  } else {
    donationLineItems[idx].lineItemAmount = evenRound(value, 2);
  }

  let newState = {
    ...state,
    donationLineItems: donationLineItems
  };
  return newState;
}

if (action.type === 'CALCULATE_TOTAL_AMOUNT') {
  let totalDonationAmount = calculatedTotalDonationAmount(state.donationLineItems);
  return {
    ...state,
    totalDonationAmount: totalDonationAmount
  };
}

if (action.type === 'HANDLE_SPONSORSHIP_CHANGE') {
  const { sponsorship, name, value } = action.payload;
  let spClone = _.cloneDeep(state.sponsorships);
  for (let i = 0; i < spClone.length; i++) {
    if (spClone[i].id === sponsorship.id) {
      spClone[i][name] = value
    }
  }

  //if sponsorship is selected then update the sponsorship and currentDonationCauseValue 
  let selectedSponsorships = _.cloneDeep(state.selectedSponsorships);
  for (let i = 0; i < selectedSponsorships.length; i++) {
    if (selectedSponsorships[i].id === sponsorship.id) {
      //set freqAmount and frequency
      selectedSponsorships[i][name] = value;
      break;
    }
  }
  let newState = {
    ...state,
    sponsorships: spClone,
    selectedSponsorships: selectedSponsorships,
  }
  return newState;
}

if (action.type === 'SET_SELECTED_SPONSORSHIP_FREQUENCY') {
  const { sponsorship, paymentFrequency } = action.payload;
  //clone sponsorships
  let spClone = _.cloneDeep(state.sponsorships);
  const oneYearForward = new Date();
  oneYearForward.setFullYear((new Date()).getFullYear() + 1);
  oneYearForward.setDate(oneYearForward.getDate() - 1);
  const fiveYearForward = new Date();
  fiveYearForward.setFullYear((new Date()).getFullYear() + 5);
  fiveYearForward.setDate(fiveYearForward.getDate() - 1);


  //first update the sponsorship array
  let indexInSpClone;
  for (let i = 0; i < spClone.length; i++) {
    if (spClone[i].id === sponsorship.id) {
      //set the payment frequency in the sponsorship object and have a separate total
      spClone[i].frequency = paymentFrequency;
      spClone[i].freqAmount = getTotalAmountWithFrequency(spClone[i]);
      if (paymentFrequency === 'MONTHLY') {
        spClone[i].endDate = formatDateToYYYYMMDD(oneYearForward);
      } else {
        spClone[i].endDate = formatDateToYYYYMMDD(fiveYearForward);
      }

      break;
    }
  }
  //if sponsorship is selected then update the sponsorship and currentDonationCauseValue 
  let selectedSponsorships = _.cloneDeep(state.selectedSponsorships);
  let donationAmount;
  for (let i = 0; i < selectedSponsorships.length; i++) {
    if (selectedSponsorships[i].id === sponsorship.id) {
      //set freqAmount and frequency
      selectedSponsorships[i].frequency = paymentFrequency;
      selectedSponsorships[i].freqAmount = getTotalAmountWithFrequency(selectedSponsorships[i]);
      if (paymentFrequency === 'MONTHLY') {
        selectedSponsorships[i].endDate = formatDateToYYYYMMDD(oneYearForward);
      } else {
        selectedSponsorships[i].endDate = formatDateToYYYYMMDD(fiveYearForward);
      }
      donationAmount = evenRound(parseFloat(state.currentDonationCauseValue) + parseFloat(selectedSponsorships[i].freqAmount) - parseFloat(sponsorship.freqAmount), 2);
      break;
    }
  }
  let newState = {
    ...state,
    sponsorships: spClone,
    selectedSponsorships: selectedSponsorships,
    currentDonationCauseValue: donationAmount ? donationAmount : state.currentDonationCauseValue
  }
  return newState;
}
//the following is for form edit and hence there should be a payload.
//otherwise just return state
if (!action.payload) {
  return state;
}

}


const selectDonationCause = (selectedDonationCauseId, donationLineItems) => {
  let currentState = {
    currentDonationCause: selectedDonationCauseId,
    currentDonationCauseValue: "",
    causeAttrDescription:""

  }
  if (_.isEmpty(selectedDonationCauseId)) {
    return {
      ...currentState,
      selectedCauseAttributes: [],
      sponsorshipCause: false,
      mediaType: ""
    }
  } else {
    for (let donationLineItem of donationLineItems) {

      let hasDescription = donationLineItem.donationCauseAttributes && donationLineItem.donationCauseAttributes.filter(sa => !_.isEmpty(sa.description)).length > 0
      let defaultCauseValue = "0.00";
      
      if (donationLineItem.causeId === selectedDonationCauseId && !donationLineItem.sponsorshipCause) {

        if (!_.isEmpty(donationLineItem.donationCauseAttributes) && donationLineItem.donationCauseAttributes?.length > 0){
          defaultCauseValue = parseFloat(donationLineItem.donationCauseAttributes[0].suggestedAmount) / 100;
        }

        return {
          ...currentState,
          selectedCauseAttributes: donationLineItem.donationCauseAttributes,
          currentDonationCauseValue: defaultCauseValue,
          sponsorshipCause: false,
          mediaType: donationLineItem.mediaType,
          hasDescription: hasDescription
        }
      } else if (donationLineItem.causeId === selectedDonationCauseId && donationLineItem.sponsorshipCause) {
        return {
          ...currentState,
          selectedCauseAttributes: [],
          sponsorshipCause: true,
          mediaType: donationLineItem.mediaType,
          hasDescription: hasDescription
        }
      }
    }
  }

  return currentState;
}
